import {
  IconPaypalBlock,
  IconStripeText,
  IconPayssionPay,
  IconAlipay,
  IconWechatPay,
  IconBankCard,
} from "@/components/Icons";
import { TPayChannelType } from "../entitys";
import { PayChannel } from "../enums";

export const PAY_CHANNEL_OPTIONS: TPayChannelType[] = [
  {
    label: <IconPaypalBlock />,
    value: PayChannel.PaypalH5,
  },
  {
    label: <IconStripeText />,
    value: PayChannel.StripeH5,
  },
  // {
  //   label: (
  //     <>
  //       <IconPaypalBlock />
  //       <strong>PC</strong>
  //     </>
  //   ),
  //   value: PayChannel.PaypalPc,
  // },
  // {
  //   label: (
  //     <>
  //       <IconStripeText />
  //       <strong>PC</strong>
  //     </>
  //   ),
  //   value: PayChannel.StripePc,
  // },
  {
    label: <IconBankCard />,
    value: PayChannel.Airwallex,
  },
  {
    label: <IconPayssionPay />,
    value: PayChannel.DanaId,
  },
  {
    label: (
      <>
        <IconAlipay />
        <strong>支付宝H5</strong>
      </>
    ),
    value: PayChannel.AlipayH5,
  },
  {
    label: (
      <>
        <IconWechatPay />
        <strong>微信H5</strong>
      </>
    ),
    value: PayChannel.WechatH5,
  },
  {
    label: (
      <>
        <IconAlipay />
        <strong>支付宝PC</strong>
      </>
    ),
    value: PayChannel.AlipayPc,
  },
  {
    label: (
      <>
        <IconWechatPay />
        <strong>微信PC</strong>
      </>
    ),
    value: PayChannel.WechatPc,
  },
];
